(ns measure.reporting-ocp.view.tabs.general
  (:require ["@mui/material/Stack$default" :as Stack]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.widgets.daterange-picker :as picker]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.radio :refer [radio-group]]
            [common.widgets.toggle-button :refer [toggle-button-group]]
            [measure.report-builder.core :refer [entity-names]]
            [measure.reporting-ocp.db.core :as form]
            [measure.reporting-ocp.db.options :as form-options]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui name-field [{:keys [entity]}]
  ($ form-field
     {:label (str/capitalize (str (get entity-names entity) " name"))
      :err-msg (form/use-error-message [:name])}
     ($ input
        (merge (form/use-bind-control [:name])
               {:autoFocus true}))))

(defui adset-channel-field []
  ($ form-field
     {:label "Adset channel"
      :err-msg (form/use-error-message [:adset-channel])}
     ($ toggle-button-group (merge (form/use-bind-control [:adset-channel]
                                                          {:on-change-event :form.report/on-change-adset-channel})
                                   {:options form-options/channel-options
                                    :size "small"}))))

(defui adset-field []
  (let [adset-channel (use-subscribe [:form.report/value [:adset-channel]])
        adset-options (form-options/use-adset-options)
        valid-adset-workflows (form/use-valid-adset-workflows)
        validation-error-message (form/use-error-message [:adset-ids])]
    ($ form-field
       {:label "Adset"
        :err-msg (if valid-adset-workflows
                   validation-error-message
                   "You are unable to mix Omnichannel Adset with non-Omnichannel Adset reports; please change your selection")}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:adset-ids])
                         (when-not valid-adset-workflows {:error true})
                         {:options adset-options
                          :multi? true
                          :disable-close-on-select true
                          :filter-options (fn [^js options ^js state]
                                            (let [input (.toLowerCase (.-inputValue state))]
                                              (if-not (str/blank? input)
                                                (.filter options (fn [^js option]
                                                                   (or (str/includes? (.. option -value toString toLowerCase) input)
                                                                       (str/includes? (.. option -label toLowerCase) input)
                                                                       (str/includes? (.. option -campaign toLowerCase) input)
                                                                       (str/includes? (.. option -campaignId toString toLowerCase) input))))
                                                options)))
                          :no-options-text (cond-> "No options"
                                             (empty? adset-channel) (str " - Did you select a channel?"))
                          :group-by (fn [^js option]
                                      (.. option -campaign))})]))))

(defui download-as-field []
  ($ form-field
     {:label "Download as"}
     (r/as-element
      [radio-group (merge (form/use-bind-control [:file-format])
                          {:options form-options/format-options})])))

(defui daterange-picker []
  ($ picker/daterange-picker
     (merge (-> (form/use-bind-control [:date-range])
                (set/rename-keys {:on-change :onChange
                                  :on-blur   :onBlur
                                  :on-focus  :onFocus}))
            {:sx #js {:width "100%"}})))

(defui datephrase-dropdown []
  (r/as-element
   [dropdown (merge (form/use-bind-control [:date-phrase])
                    {:options form-options/date-phrase-options})]))

(defui date-range-field [{:keys [entity]}]
  ($ form-field
     {:label "Date range"
      :sx #js {:flexBasis "50%"}}
     (if (= entity :report)
       ($ daterange-picker)
       ($ datephrase-dropdown))))

(defui timezone-field []
  ($ form-field
     {:label "Timezone"
      :err-msg (form/use-error-message [:timezone])
      :sx #js {:flexBasis "50%"}}
     (r/as-element
      [dropdown (merge (form/use-bind-control [:timezone])
                       {:options form-options/timezone-options})])))

(defui schedule-field []
  ($ form-field
     {:label "Schedule interval"}
     (r/as-element
      [radio-group (merge (form/use-bind-control [:schedule])
                          {:options form-options/schedule-options})])))

(defui general-tab [{:keys [entity]}]
  ($ :<>
     ($ name-field {:entity entity})
     ($ adset-channel-field)
     ($ adset-field)
     ($ download-as-field)

     ($ Stack {:flex-direction "row" :gap 3}
        ($ date-range-field {:entity entity})
        ($ timezone-field))

     (when (= entity :report-schedule)
       ($ schedule-field))))
